import { EventEmitter } from 'events'

abstract class Player extends EventEmitter {
  plugins: Array<any>

  public abstract play(time?: number): void

  public abstract pause(): void

  public abstract getDuration(): number

  public abstract getTime(): number

  public abstract setTime(time: number): void

  public abstract muted(mute: boolean): boolean

  public abstract destroy(): boolean

  public abstract stop(): void

  getSchedule(): number {
    return parseFloat(`${((this.getTime() / this.getDuration()) * 100).toFixed(2)}`)
  }
}

export default Player
